import React from 'react'
import { Container } from "react-bootstrap";
import fondoHome from "./fondo-home.jpg";
import { Button } from "react-bootstrap";

export default function InitComponent() {
  const telefono = 1553745044;
  return (
    <header
      className="position-relative text-white text-center d-flex align-items-center justify-content-center"
      style={{
        backgroundImage: `url(${fondoHome})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "50vh",
      }}
    >
      <Container
        className="d-flex flex-column flex-md-row justify-content-between align-items-center w-100 text-white p-4"
        style={{
          boxShadow: "0px 4px 20px rgba(57, 57, 57, 0.5)",
          backgroundColor: "rgba(57, 57, 57, 0.5)",
          borderRadius: "32px",
          maxWidth: "90%",
        }}
      >
        <h1
          className="text-center text-md-start mb-3 mb-md-0"
          style={{
            cursor: "default",
            lineHeight: "1.2",
            letterSpacing: "1px"
          }}
        >
          Buenos Aires Vintage
        </h1>

        <Button
          variant="success"
          onClick={() => window.open(`https://wa.me/${telefono}`, "_blank")}
          className="d-flex align-items-center gap-2"
          style={{
            fontSize: "16px",
            padding: "10px 20px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="white"
          >
            <path d="M12 0C5.372 0 0 5.372 0 12c0 2.162.577 4.27 1.671 6.122L0 24l6.208-1.646A11.992 11.992 0 0 0 12 24c6.628 0 12-5.372 12-12S18.628 0 12 0zm0 22.08a9.949 9.949 0 0 1-5.38-1.564l-.383-.24-3.685.975.986-3.604-.248-.396A9.92 9.92 0 0 1 2.08 12c0-5.474 4.446-9.92 9.92-9.92s9.92 4.446 9.92 9.92-4.446 9.92-9.92 9.92zm5.78-7.372c-.31-.157-1.837-.908-2.122-1.01-.285-.103-.494-.157-.703.157-.207.31-.804 1.01-.987 1.216-.183.207-.365.232-.675.078-.31-.157-1.31-.483-2.49-1.54-.92-.82-1.54-1.837-1.717-2.147-.183-.31-.02-.477.138-.634.143-.143.31-.365.466-.548.155-.183.207-.31.31-.517.103-.207.052-.388-.026-.548-.078-.157-.703-1.697-.963-2.332-.253-.609-.508-.526-.703-.536-.18-.007-.388-.01-.597-.01s-.547.078-.833.388c-.285.31-1.09 1.07-1.09 2.623s1.115 3.044 1.27 3.25c.155.207 2.19 3.34 5.31 4.687.74.318 1.317.508 1.77.651.744.237 1.418.204 1.95.123.594-.088 1.837-.752 2.097-1.48.26-.728.26-1.352.183-1.48-.078-.127-.285-.204-.594-.365z" />
          </svg>
          Contacto
        </Button>
      </Container>
    </header>
  )
}